import { useCallback } from 'react';
import { Button } from '~/components/ui/Button';
import { IconButton } from '~/components/ui/IconButton';
import type { OrganizationData } from '~/types/organization';
import { redirectToOrgBillingPage } from '~/utils/subscription';

interface TeamMembersHeaderProps {
  showTeamSettings: VoidFunction;
  activeOrganization: OrganizationData;
  showPricingOverlay: VoidFunction;
}

export const TeamMembersHeader = (props: TeamMembersHeaderProps) => {
  const { activeOrganization, showPricingOverlay, showTeamSettings } = props;
  const isAdmin = activeOrganization.role === 'admin';

  const handleRedirectToOrgBillingPage = useCallback(() => {
    redirectToOrgBillingPage(activeOrganization);
  }, [activeOrganization]);

  return (
    <div className="flex items-center flex-wrap md:flex-nowrap justify-between gap-4 w-full">
      <h2 className="shrink min-w-25 text-lg font-semibold truncate">{activeOrganization.name}</h2>

      {isAdmin && (
        <div className="shrink-0 flex items-center gap-2">
          <Button
            variant="secondary"
            onClick={showPricingOverlay}
            size="md"
            startIcon="i-heroicons:credit-card !h-4.5 !text-[18px]"
          >
            Plan
          </Button>
          <Button
            variant="secondary"
            onClick={handleRedirectToOrgBillingPage}
            size="md"
            startIcon="i-heroicons:arrow-top-right-on-square !h-4.5 !text-[18px]"
          >
            Manage Billing
          </Button>

          <IconButton size="md" icon="i-ph:gear-six !size-4.5" onClick={showTeamSettings} />
        </div>
      )}
    </div>
  );
};
